import $ from "jquery";
import Cookies from "js-cookie";


var TrackingConsent = (function () {
  const tracking = {};

  // ============================================================
  const defaultConsent = (value) => {
    value === "granted" ? "granted" : "denied";
  };

  // ============================================================
  const processCookies = () => {
    tracking.ad_storage = defaultConsent(Cookies.get("ad_storage"));
    tracking.ad_user_data = defaultConsent(Cookies.get("ad_user_data"));
    tracking.ad_personalization = defaultConsent(
      Cookies.get("ad_personalization"),
    );
    tracking.analytics_storage = defaultConsent(Cookies.get("analytics_storage"));
    tracking.functionality_storage = defaultConsent(
      Cookies.get("functionality_storage"),
    );
    tracking.security_storage = defaultConsent(Cookies.get("security_storage"));
    tracking.personalization_storage = defaultConsent(
      Cookies.get("personalization_storage"),
    );
  };

  // ============================================================
  let cookiesProcessed = false;
  const ensureCookiesProcessed = () => {
    if (!cookiesProcessed) {
      processCookies();
      cookiesProcessed = true;
    }
  };

  // ============================================================
  const needSendConsent = () => {
    if (typeof gtag === "undefined") return false;
    ensureCookiesProcessed();

    if (!tracking.isSetted) return true;

    return [
      "ad_storage",
      "ad_user_data",
      "ad_personalization",
      "analytics_storage",
      "functionality_storage",
      "security_storage",
      "personalization_storage",
    ].some((key) => Cookies.get(key) && Cookies.get(key) !== tracking[key]);
  };

  // ============================================================
  const setGtagConsent = () => {
    ensureCookiesProcessed();

    if (!needSendConsent()) return;

    const action = tracking.isSetted ? "update" : "default";

    gtag("consent", action, {
      ad_storage: tracking.ad_storage,
      ad_user_data: tracking.ad_user_data,
      ad_personalization: tracking.ad_personalization,
      analytics_storage: tracking.analytics_storage,
      functionality_storage: tracking.functionality_storage,
      security_storage: tracking.security_storage,
      personalization_storage: tracking.personalization_storage,
    });

    tracking.isSetted = true;
  };

  // ============================================================
  return {
    setGtagConsent,
    needSendConsent,
    processCookies,
    ensureCookiesProcessed,
    tracking,
  };
})();

export default TrackingConsent;
